import { lang } from 'zf-infra';
import type { MenuProps } from '../../base';
import type { OperatorMenuItem } from './types';

export class OperatorService {

  combine(items: OperatorMenuItem[]): Required<MenuProps>['items'] {
    const groupItems = lang.groupBy(items, 'groupName');

    return Object.keys(groupItems).map(groupName => {
      const items = groupItems[groupName];
      const children = items.map(item => ({ ...item, key: item.label }));

      return {
        type: 'group',
        key: groupName,
        label: groupName,
        children
      };
    });
  }

}
